<sd-4-5-1-dialog #dialog [wctSdDialogDestroyComponentAfterClose]="this" open="true" no-close-button="true">
  <div slot="headline" class="sd-headline sd-headline--size-3xl">
    {{ message || ('userDeleteDialog.headline' | transloco) }}
  </div>

  <form #form class="inputs" (submit)="submit($event, form.reportValidity())">
    <sd-4-5-1-input readonly value="{{ userInfo.firstName }} {{ userInfo.lastName }} ({{ userInfo.mailAddress }})">
      <span slot="label">
        {{ 'userDeleteDialog.user' | transloco }}
      </span>
    </sd-4-5-1-input>

    <div wctLoadingIndicator [apiSignal]="deleteReasons">
      <sd-4-5-1-select hoist required placeholder="{{ 'userDeleteDialog.reasonPlaceholder' | transloco }}" [attr.disabled]="!deleteReasons() ? true : null" [wctSdSignalModel]="selectedReason">
        <span slot="label">
          {{ 'userDeleteDialog.reason' | transloco }}
        </span>

        @for (reason of deleteReasons(); track reason.key) {
          <sd-4-5-1-option [value]="reason.key">
            {{ reason.label }}
          </sd-4-5-1-option>
        }

        <sd-4-5-1-option [value]="selectKeyOther">
          {{ 'userDeleteDialog.reasonOther' | transloco }}
        </sd-4-5-1-option>
      </sd-4-5-1-select>
    </div>

    @if (selectedReason() === selectKeyOther) {
      <sd-4-5-1-input required [wctSdSignalModel]="comment">
        <span slot="label">
          {{ 'userDeleteDialog.remark' | transloco }}
        </span>
      </sd-4-5-1-input>
    }
  </form>


  <div class="button-row" slot="footer">
    <sd-4-5-1-button variant="tertiary" (click)="hide()">
      {{ cancel || ('userDeleteDialog.cancel' | transloco) }}
    </sd-4-5-1-button>

    <sd-4-5-1-button (click)="form.requestSubmit()" [loading]="loading()">
      {{ delete || ('userDeleteDialog.delete' | transloco) }}
    </sd-4-5-1-button>
  </div>
</sd-4-5-1-dialog>
